import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Phase 10B 2050 StatusPill — 6 muted tones (neutral, success, warning,
 * danger, info, gold). No neon. Optional dot indicator on the left.
 * Tones with optimistic outcomes get a subtle shine sweep (handled in CSS).
 */
const toneClasses = {
  neutral: "pill-2050 pill-neutral",
  success: "pill-2050 pill-success",
  warning: "pill-2050 pill-warning",
  danger:  "pill-2050 pill-danger",
  info:    "pill-2050 pill-info",
  gold:    "pill-2050 pill-gold",
};

const dotColors = {
  neutral: "bg-ink-500",
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  danger:  "bg-rose-500",
  info:    "bg-sky-500",
  gold:    "bg-gold",
};

const StatusPill = React.forwardRef(
  ({ className, tone = "neutral", label, children, dot = false, ...props }, ref) => {
    const toneClass = toneClasses[tone] || toneClasses.neutral;
    return (
      <span
        ref={ref}
        className={cn(toneClass, className)}
        {...props}
      >
        {dot ? (
          <span className={cn("w-1.5 h-1.5 rounded-full", dotColors[tone] || dotColors.neutral)} />
        ) : null}
        {label ?? children}
      </span>
    );
  }
);
StatusPill.displayName = "StatusPill";

export { StatusPill };
